import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

export function TanstackDevtools() {
  return (
    <div className="tailwind-root contents ">
      <div className="[&_.tsqd-open-btn-container]:bottom-15! [&_.tsqd-open-btn-container]:scale-75!">
        <ReactQueryDevtools buttonPosition="bottom-left" />
      </div>
    </div>
  );
}
